const StatusBadge = ({ status, fromWhre }) => {

    const isFulfilled = status === 'Success';

    return (
        <div className="status-badge-new"
            style={{
                backgroundColor: isFulfilled ? '#E8F5E9' : '#FFF3E0',
                color: isFulfilled ? '#32BF59' : '#FFC409',
            }}
        >
            {isFulfilled ? 'Fulfilled' : 'Unfulfilled'}
        </div>
    );
};

export default StatusBadge